import {
  BlocksEditContainer,
  EditorUIProvider
} from "@pathwright/blocks-engine"
import { BlocksEditContainerProps } from "@pathwright/blocks-engine/src/editor/BlocksEditContainer"
import { ContentEditor } from "../editor/ContentEditor"

const BlocksContentEditorContainer = (props: Omit<BlocksEditContainerProps, "children">) => {
  return (
    <BlocksEditContainer {...props}>
      <EditorUIProvider>
        <ContentEditor />
      </EditorUIProvider>
    </BlocksEditContainer>
  )
}

export default BlocksContentEditorContainer
